import { Visit } from '@ravago/shared/page-data/models/elements/user-registration.model';

function getCookie(name: string): string | undefined {
   const regex = new RegExp(`(?:^|; )${name}=([^;]*)`);
   const match = regex.exec(document.cookie);
   return match ? decodeURIComponent(match[1]) : undefined;
}

export function collectVisitData(): Visit | undefined {
   const campaignUrl = getCookie('__gtm_campaign_url');
   if (!campaignUrl) return undefined;

   try {
      const url = new URL(campaignUrl);
      return {
         visitorId: localStorage.getItem('visitor_id') ?? '',
         utm: {
            source: url.searchParams.get('utm_source') ?? '',
            medium: url.searchParams.get('utm_medium') ?? '',
            campaign: url.searchParams.get('utm_campaign') ?? '',
            content: url.searchParams.get('utm_content') ?? ''
         }
      };
   } catch {
      return undefined;
   }
}
